export default __webpack_public_path__ + "static/media/error.fe9aa0a1.png";